import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { Box } from '../Styled'
import { FlexWrapper } from 'lib/ui/components/FlexWrapper'
import { FormattedMessage } from 'react-intl'
import { getOrders, getFetching } from 'lib/core/data/customer/orders/selectors'
import { useSelector } from 'react-redux'
import { Pagination } from 'lib/shared/components'
import { ReactComponent as ArrowLeft } from 'resources/svg/icons/arrow-circle-left.svg'
import { ReactComponent as ArrowRight } from 'resources/svg/icons/arrow-circle-right.svg'
import { Item } from './components/Item'

export const OrderHistory = () => {
  const orders = useSelector(getOrders)
  const isFetching = useSelector(getFetching)
  const ordersPerPage = 5
  const [actualPage, setActualPage] = useState(0)

  const handlePageChange = (e: number) => {
    setActualPage(e - 1)
  }

  return (
    <Box>
      <FlexWrapper className='flex-box'>
        <h3>
          <FormattedMessage id='customer.account.dashboard.orders' />
        </h3>
        <Link to='/customer/account/orders'>
          <FormattedMessage id='customer.account.dashboard.manage' />
        </Link>
      </FlexWrapper>
      {!orders.length && !isFetching && (
        <p>
          <FormattedMessage id='customer.account.dashboard.orderHistory.empty' />
        </p>
      )}
      <Box className='border-box'>
        {orders.slice((actualPage * ordersPerPage), (actualPage * ordersPerPage) + ordersPerPage).map((order) => {
          return (
            <Item
              key={order.id}
              order={order}
            />
          )
        })}
        <div>
          <Pagination
            onChange={handlePageChange}
            prevPageContent={<ArrowLeft />}
            nextPageContent={<ArrowRight />}
            pageSize={ordersPerPage}
            firstPageContent=''
            lastPageContent=''
            totalItems={orders.length}
            pageRangeDisplayed={1}
            currentPage={actualPage + 1}
          />
        </div>
      </Box>
    </Box>
  )
}
